import BaseModel from './BaseModel';
export default class SiteInfo extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.name = data.name || this.translate.name || undefined;
        this.key = data.key || this.translate.key || undefined;
        this.value = data.value || this.translate.value || undefined;
        this.createdDate = data.createdDate || undefined
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            key: this.key,
            value: this.value
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                siteInfoId: this.translate.siteInfoId || this.id,
                name: this.name,
                key: this.key,
                value: this.value,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}
